import React from 'react'
import {Helmet} from "react-helmet";
import PageTitle from '../../../pagetitle/PageTitle'
import BronzSponsorCard from '../../../sponsorcard/BronzSponsorCard'

export default function BronzSponsorlar()
{
    const title = "OKAF Bronz Sponsorlar- Samsun Üniversitesi";
    const description = "Samsun Üniversitesi ev sahipliğinde gerçekleşecek olan Orta Karadeniz Kariyer Fuarı (OKAF)'ın bronz sponsorlarına ulaşmak için tıklayınız!";
    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Helmet>
            <PageTitle name="Bronz Sponsorlar"></PageTitle>
            <BronzSponsorCard />
        </>
    )
}
